<template>
  <div class="sectionBox">
    <div class="alFitrBox langEn" :class="lang == 'ar' ? 'langAr':''">
      <span class="rulesBtn" @click="openRules"></span>
      <p class="urlBtnBox" @click="urlBtn"></p>
      <div class="popBox" v-if="rulesFlag">
        <div class="popContent" :class="lang == 'ar' ? 'popContentAr':''">
        <span class="closePop" @click="closeRules"></span>
      </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "alFitr",
  data() {
    return {
      lang:'en',
      rulesFlag: false
    };
  },
  mounted() {
      this.$completes.complete("getUserInfo");
      window.getUserInfo = this.getUserInfo;
      window['getUserInfo'] = (data) => {
          this.getUserInfo(data);
      }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      if (langs == "ar") {
        this.$i18n.locale = "ar";
        document.title = 'أبريل الأسطوري';
        this.lang = "ar";
      } else {
        this.$i18n.locale = "en";
        this.lang = "en";
        document.title = 'Legendary April';
      }
      
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },
    urlBtn() {
      window.location.href = "https://laylachat.feishu.cn/wiki/RWjyw5m4fijqHEkrU25cz09qnNg?renamingWikiNode=false&sheet=b5FqYj"
    },
    openRules() {
      this.rulesFlag = true;
      this.stopScroll();
    },
    closeRules() {
      this.rulesFlag = false;
      this.canScroll();
    }
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.sectionBox{
  height: 100vh;
  /* background: linear-gradient(to bottom, rgba(131, 16, 99, 1), rgba(0, 52, 78, 1), rgba(147, 11, 108, 1)); */
}
.alFitrBox{
  width: 640px;
  height: 4664px;
  position: relative;
}
.langEn{
  background: url('../../assets/legendaryApril/en.png') no-repeat;
  background-size: 100% 100%;
}
.langAr{
  height: 4652px;
  background: url('../../assets/legendaryApril/ar.png') no-repeat;
  background-size: 100% 100%;
}
.urlBtnBox{
  width: 530px;
  height: 60px;
  position: absolute;
  top:  265px;
  left: 50%;
  transform: translateX(-50%);
}
.rulesBtn{
  position: absolute;
  top: 30px;
  right: 20px;
  width: 50px;
  height: 50px;
}
.popBox{
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.5);
}
.popContent{
  width: 612px;
  height: 1062px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: url('../../assets/legendaryApril/rules_en.png') no-repeat;
  background-size: 100% 100%;
}
.popContentAr{
  height: 1087px;
  background: url('../../assets/legendaryApril/rules_ar.png') no-repeat;
  background-size: 100% 100%;
}
.closePop{
  position: absolute;
  width: 50px;
  height: 50px;
  top: 0;
  right: 0px;
}
</style>
